import React from 'react';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';

interface JsonTableProps {
  jsonData: Record<string, any> | null;
}

function renderValue(value: any): string {
  // Handle rendering of nested objects or non-primitive data types
  if (typeof value === 'object') {
    return JSON.stringify(value);
  }
  return String(value);
}

function JsonTable({ jsonData }: JsonTableProps) {
  if (!jsonData) {
    return null;
  }

  const dataEntries = Object.entries(jsonData).sort(([keyA], [keyB]) => {
    // Sort by key alphabetically
    return keyA.localeCompare(keyB);
  });

  return (
    <TableContainer component={Paper}>
      <Table aria-label="JSON Data Table">
        <TableBody>
          {dataEntries.map(([key, value]) => (
            <TableRow key={key}>
              <TableCell component="th" scope="row">
                <Typography variant="subtitle2">{key}</Typography>
              </TableCell>
              <TableCell>{renderValue(value)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default JsonTable;
